import forOwn from 'mout/object/forOwn'
import uuid from 'uuid/v1'
import { db } from "../../../config/firebaseconfig"
import { getAllTeacherNames } from './'
import getTrueProps from '../../getTrueProps'

/**
 * Creates all classes that are mentioned in the upload data but
 * have not been created yet in the database and associates
 * these classes with their teachers.
 * @param {array} uploadData The parsed array of row objects from the csv upload
 * @param {object} school The school object
 * @param {string} schoolYear The active school year ('2018' for 2018-19, for example)
 * @returns {array} the objects of the created classes
 */
export default function createClasses (uploadData, school, schoolYear) {
  let createClassesPromises = []
  let createdClasses = []
  // create an object that has all of the teachers and an array of each of their class periods
  const subjects = ['english', 'homeroom', 'math', 'science']
  const allNames = getAllTeacherNames(uploadData).teacherNamesOnly
  let classInfo = {}
  allNames.forEach(name => classInfo[name.toLowerCase()] = {})

  // go through each row and add classes to classInfo as is relevant
  uploadData.forEach(record => {
    subjects.forEach(subject => {
      const teacherName = record[`${subject}teacher`].toLowerCase()
      if (classInfo[teacherName]) {
        const period = record[`${subject}period`]
        if (period !== 'BLANK' && !classInfo[teacherName][period]) {
          classInfo[teacherName][period] = true
        }
      }
    })
  })

  // get all classes and teachers in the school
  const fetchTeachers = db.collection('educators').where('school', '==', school.id).get()
  const fetchClasses = db.collection('classes').where('school', '==', school.id).get()
  return Promise.all([fetchTeachers, fetchClasses])
    .then(results => {
      const [ teacherDocs, classesDocs ] = results
      let teachers = {}
      let classes = {}
      teacherDocs.forEach(doc => {
        if (doc.exists) {
          const data = doc.data()
          const ident = data.email || data.username
          teachers[ident] = doc.data()
        }
      })
      classesDocs.forEach(doc => {
        if (doc.exists) classes[doc.id] = doc.data() 
      })
      forOwn(classInfo, (periods, teacherName) => {
        const teach = teachers[teacherName]
        if (teach) {
          const classList = getTrueProps(teach.classes)
          let classMap = {}
          classList.forEach(cl => {
            const theClass = classes[cl]
            classMap[theClass.period] = theClass
          })
          Object.keys(periods).forEach(period => {
            if (period && !classMap[period]) {
              const batch = db.batch()
              const time = Date.now()
              // Add the class record
              const id = uuid()
              const classRef = db.collection('classes').doc(id)
              const newClass = {
                id,
                name: period,
                accountType: 'Class',
                created: time,
                lastModified: time,
                groupType: 'Class',
                district: school.district,
                school: school.id,
                teacher: teach.id,
                period,
                state: school.state,
                students: {},
                schoolYear,
              }
              batch.set(classRef, newClass)
              
              // Add the class to the parent
              const teacherRef = db.collection('educators').doc(teach.id)
              const classKey = `classes.${id}`
              batch.update(teacherRef, {[classKey]: true})
              const commit = batch.commit()
              createdClasses.push(newClass)
              createClassesPromises.push(commit)
            }
          })
        }
      })
      return Promise.all(createClassesPromises)
    })
    .then(() => {
      return createdClasses
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/createClasses.js